import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FirebaseService } from '../service/firebase.service';
import { DialogToolbarComponent} from './dialog-toolbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from '../services/shared.service';
import { TranslationPipe } from '../shared/pipes/translation.pipe';





@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  buttonValue:string;



  constructor(
      public firebaseService: FirebaseService,
      public sharedService: SharedService,
      public dialog: MatDialog,
    private snackBar: MatSnackBar,
    public translation: TranslationPipe) { }

  /**
   * Open logout modal
   * */
    openDialog(): void {
      const dialogRef = this.dialog.open(DialogToolbarComponent, {
        width: '250px',
        data: {buttonValue: this.buttonValue }
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result == "logout"){
          this.firebaseService.logout();
          this.snackBar.open(this.translation.transform('loggedOut') as string, 'OK', {
            duration: 5000
          })

        }

      });
    }

  ngOnInit() {
  }



}
